import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";

function ErrorDialog({ open, onClose, message }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Execution Error</DialogTitle>
      <DialogContent>
        <TextField
          value={message}
          multiline
          fullWidth
          variant="outlined"
          InputProps={{ readOnly: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            navigator.clipboard.writeText(message);
          }}
        >
          Copy
        </Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrorDialog;
